<template>
  <div class="customer-select">
    <div class="customer-select__aside">
      <CustomerSelectContent
        v-model="selectCustomer"
        :business-type="props.businessType"
        :params="params"
      ></CustomerSelectContent>
    </div>
    <div class="customer-select__right">
      <CustomerSelectChecked v-model:data-list="selectCustomer"></CustomerSelectChecked>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, computed, defineExpose, defineProps } from 'vue'
import CustomerSelectChecked from './customer-select-checked.vue'

import CustomerSelectContent from './customer-select-content.vue'
// props
const props = defineProps({
  businessType: {
    type: Number,
    default: 100,
    require: true
  }
})
// data
const data = ref({})
const params = ref({})
const selectCustomer = ref([])
// computed
const dataControl = computed(() => data)

// 获取值
const getData = () => {
  return selectCustomer.value
}
// 设置值
const setData = (val) => {
  selectCustomer.value.splice(0, selectCustomer.value.length, ...val)
}
// lice-cycle
onMounted(() => {
  console.log('dataControl', dataControl.value)
})
// expose
defineExpose({
  getData,
  setData
})
</script>

<style lang="less" scoped>
.customer-select {
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #f2f3f5;
  height: 495px;

  &__aside {
    flex: 1;
    min-width: 0;
    border-right: 1px solid #f2f3f5;
  }

  &__right {
    width: 368px;
    min-width: 0;
  }
}
</style>
